var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.575 12.7246H13.7V4.89961C13.7 4.36211 13.2625 3.91211 12.725 3.91211C12.175 3.91211 11.75 4.34961 11.75 4.89961V13.7121C11.75 14.2621 12.1875 14.6871 12.725 14.6871H19.575C20.125 14.6871 20.5625 14.2496 20.5625 13.7121C20.5625 13.1621 20.125 12.7246 19.575 12.7246Z",
    fill: "#22A873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 7.83828H1.9625V4.90078C1.9625 4.36328 1.525 3.92578 0.9875 3.92578C0.45 3.92578 0 4.36328 0 4.90078V8.81328C0 9.35078 0.4375 9.78828 0.975 9.78828H4.8875C5.425 9.78828 5.8625 9.35078 5.8625 8.81328C5.875 8.27578 5.4375 7.83828 4.9 7.83828Z",
    fill: "#22A873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29961 16.5125C2.21211 15.9125 1.81211 15.5875 1.27461 15.5875C0.737109 15.5875 0.349609 16.0125 0.349609 16.5625C0.349609 16.725 0.412109 16.8625 0.424609 17.0375C1.91211 23 7.28711 27.425 13.7121 27.425C21.2871 27.425 27.4246 21.2875 27.4246 13.7125C27.4246 6.1375 21.2871 0 13.7246 0C7.88711 0 2.91211 3.6625 0.937109 8.8125H3.06211C4.89961 4.775 8.96211 1.9625 13.7121 1.9625C20.1996 1.9625 25.4621 7.225 25.4621 13.7125C25.4621 20.2 20.1996 25.4625 13.7121 25.4625C8.23711 25.4625 3.64961 21.7125 2.34961 16.65",
    fill: "#22A873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/payment-history.03da70aa9098226596b77bef2b8b9235.svg";
export { ForwardRef as ReactComponent };